/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { ProtectedAwsWorkloadsStore } from '../stores/ProtectedAwsWorkloadsStore';

export const ProtectedAwsWorkloadsContext = createContext<ProtectedAwsWorkloadsStore>({} as ProtectedAwsWorkloadsStore);
